import React, { useState, useEffect } from "react";
import { Modal } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { gql, useLazyQuery } from "@apollo/client";
import { setUserInfo } from "../../store/features/UserInfo";
import PricingPage from "../../pages/main/ManageBilling/PricingPage";
import "./style.css";

const GET_COACH_SUBSCRIPTION_STATUS = gql`
  query getCoachSubscriptionStatus {
    getCoachSubscriptionStatus {
      status
      hasActiveSubscription
      trialEndDate
      trialStartDate
      currentPeriodStart
      currentPeriodEnd
      cancelAtPeriodEnd
      planType
    }
  }
`;

export default function SubscriptionModal({
  open,
  onSuccess,
  onCancel,
  checkoutPromptKind = "trial",
}) {
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.userInfo.userInfo);
  const [refreshing, setRefreshing] = useState(false);

  const [getSubscriptionStatus] = useLazyQuery(GET_COACH_SUBSCRIPTION_STATUS, {
    fetchPolicy: "network-only",
  });

  // Listen for subscription success event
  useEffect(() => {
    if (!open) return;

    const handleSubscriptionSuccess = async () => {
      setRefreshing(true);
      try {
        // Wait a bit for backend to process
        await new Promise((resolve) => setTimeout(resolve, 2000));

        // Refresh subscription status
        const result = await getSubscriptionStatus();
        const subscriptionData = result?.data?.getCoachSubscriptionStatus;

        if (subscriptionData) {
          // Update store
          dispatch(
            setUserInfo({
              ...userInfo,
              subscriptionStatus: subscriptionData,
            })
          );

          // Check if subscription is now active
          if (
            subscriptionData.hasActiveSubscription &&
            subscriptionData.status !== "TRIAL" &&
            subscriptionData.status !== "TRIALING"
          ) {
            onSuccess?.();
          }
        }
      } catch (error) {
        console.error("Failed to refresh subscription status:", error);
      } finally {
        setRefreshing(false);
      }
    };

    // Listen for subscription success from Stripe redirect
    window.addEventListener("subscription-success", handleSubscriptionSuccess);

    return () => {
      window.removeEventListener(
        "subscription-success",
        handleSubscriptionSuccess
      );
    };
  }, [open, getSubscriptionStatus, dispatch, userInfo, onSuccess]);

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      width={1000}
      centered
      className="subscription-modal"
      destroyOnClose
    >
      <PricingPage
        isModal={true}
        isRefreshing={refreshing}
        checkoutPromptKind={checkoutPromptKind}
      />
    </Modal>
  );
}
